/*
 * Copyright (c) 2023 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, December 23rd 2023, 3:04:54 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid";

export interface CheckBoxSelectorProps<TOption> {
  values: TOption[];
  options: TOption[];
  getOptionValue?: (chosenValue: TOption) => any;
  getOptionLabel?: (chosenValue: TOption) => React.ReactNode;
  onClickItem: (item: TOption) => void; // Simply handle the click event on an item and do not do anything with the values so that this component can be used by both controlled and uncontrolled components
}

export const CheckBoxSelector = <TOption,>(props: CheckBoxSelectorProps<TOption>) => {
  return (
    <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }} sx={{ overflow: "auto" }}>
      {props.options.map((item, index) => {
        const optionValue = props.getOptionValue?.(item) ?? item;
        const optionLabel = props.getOptionLabel?.(item) ?? item;
        return (
          <Grid item xs={2} sm={4} md={4} key={index}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={(props.values as any).includes(optionValue)}
                  onChange={() => {}}
                  //   name={optionLabel}
                />
              }
              label={optionLabel}
              onClick={() => props.onClickItem(optionValue)}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
